define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var ServerModel = /** @class */ (function () {
        function ServerModel(data) {
            this.Id = ko.observable(0);
            this.IpAddress = ko.observable();
            this.Domain = ko.observable();
            this.AdminUserName = ko.observable();
            this.Password = ko.observable();
            this.PasswordPreview = ko.observable();
            this.LoginTypeId = ko.observable();
            this.LoginTypeName = ko.observable();
            this.DnsZoneName = ko.observable();
            this.DnsType = ko.observable();
            this.DnsValue = ko.observable();
            this.DnsProvider = ko.observable();
            this.Ttl = ko.observable(10);
            this.CreateUser = ko.observable(false);
            this.CloudStorageEnabled = ko.observable(false);
            this.BackupConfiguration = ko.observable(false);
            this.HasLocations = ko.observable(false);
            this.ServerGroupId = ko.observable();
            this.ServerGroupName = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, ServerModel.Mapping, self);
            }
        }
        ServerModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new ServerModel(options.data);
            }
        };
        return ServerModel;
    }());
    return ServerModel;
});
//# sourceMappingURL=ServerModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/ServerModel.js
// module id = 26
// module chunks = 2